import React from 'react';
import Nav from './Nav';
import Hero from './Hero';
import ProblemSection from './ProblemSection';
import FeaturesSection from './FeaturesSection';
import HowItWorks from './HowItWorks';
import AudiencesSection from './AudiencesSection';
import FormsSection from './FormsSection';
import ContactSection from './ContactSection';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="font-['Inter'] antialiased">
      <Nav />
      <Hero />
      <ProblemSection />
      <FeaturesSection />
      <HowItWorks />
      <AudiencesSection />
      <FormsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default LandingPage;

